import { gql } from '@apollo/client'

export const AI_CHAT_CONVERSATION_QUERY = gql`
  query aiChatConversation($id: ID!) {
    aiChatConversation(id: $id) {
      id
      title
      status
      totalInputTokens
      totalOutputTokens
      createdAt
      updatedAt
      messages {
        id
        role
        content
        status
        toolCalls
        usage
        viewContext
        createdAt
        updatedAt
        uploads {
          attachmentFilename
          attachmentUrl
        }
      }
    }
  }
`
